import {
  Card,
  CardContent,
  Stack,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';

SnapshotsFilter.propTypes = {
  filters: PropTypes.object,
  setFilters: PropTypes.func,
  filterGroups: PropTypes.array
};

export default function SnapshotsFilter({ filters, setFilters, filterGroups }) {
  const toggleOption = (groupId, optionId) => {
    setFilters((prev) => ({
      ...prev,
      [groupId]: {
        ...prev[groupId],
        [optionId]: !prev[groupId]?.[optionId]
      }
    }));
  };

  const clearFilters = () => {
    setFilters({});
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={1} mb={1}>
          <Typography variant="h6" mb={1}>
            Refine results
          </Typography>
          <Button size="small" variant="outlined" fullWidth onClick={clearFilters}>
            Clear all filters
          </Button>
        </Stack>

        <Stack spacing={1} sx={{ maxHeight: '50vh', overflowY: 'auto' }}>
          <FormControlLabel
            control={
              <Checkbox
                disableRipple
                size="small"
                checked={Boolean(filters.global)}
                onChange={() =>
                  setFilters((prev) => ({
                    ...prev,
                    global: !prev.global
                  }))
                }
              />
            }
            label={<Typography variant="subtitle2">Team Snapshots Only</Typography>}
          />

          {filterGroups.map((group) => (
            <Accordion
              key={group.id}
              disableGutters
              elevation={0}
              sx={{
                '&:before': { display: 'none' },
                bgcolor: 'transparent'
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  px: 0,
                  minHeight: 32,
                  '& .MuiAccordionSummary-content': {
                    my: 0
                  }
                }}
              >
                <Typography variant="subtitle1">{group.label}</Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ p: 0 }}>
                <Stack spacing={0}>
                  {group.options.map((option) => (
                    <FormControlLabel
                      key={option.id}
                      control={
                        <Checkbox
                          disableRipple
                          size="small"
                          checked={Boolean(filters[group.id]?.[option.id])}
                          onChange={() => toggleOption(group.id, option.id)}
                        />
                      }
                      label={<Typography variant="subtitle2">{option.label}</Typography>}
                    />
                  ))}
                </Stack>
              </AccordionDetails>
            </Accordion>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}
